var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { staticClass: "lst_sitemap" },
    _vm._l(_vm.filterSiteMap, function(map, mapIdx) {
      return _c(
        "li",
        {
          key: mapIdx,
          staticClass: "col_group",
          class: { is_col_merge2: map.isMerged }
        },
        [
          _vm._l(map.menus, function(menu, menuIdx) {
            return _vm.isShow(menu)
              ? [
                  _c(
                    "em",
                    {
                      key: "gnb_footer_menu_em_" + menu.msgTitleId,
                      staticClass: "title_txt is_pc_show"
                    },
                    [
                      !menu.externalUrl
                        ? _c("span", [_vm._v(_vm._s(_vm.$t(menu.msgTitleId)))])
                        : _c(
                            "a",
                            {
                              attrs: {
                                href: menu.externalUrl,
                                target: menu.target
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t(menu.msgTitleId)))]
                          )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      key: "gnb_footer_menu_a_" + menu.msgTitleId,
                      staticClass: "title_txt is_m_show",
                      class: _vm.showCollapse[mapIdx][menuIdx]
                        ? "collapsed"
                        : null,
                      attrs: {
                        "aria-controls": "gnb_footer_menu_" + menu.msgTitleId,
                        "aria-expanded": _vm.showCollapse[mapIdx][menuIdx]
                          ? "true"
                          : "false"
                      },
                      on: {
                        click: function($event) {
                          _vm.showCollapse[mapIdx][menuIdx] = !_vm.showCollapse[
                            mapIdx
                          ][menuIdx]
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t(menu.msgTitleId)) +
                          "\n      "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  !map.isMerged
                    ? _c(
                        "b-collapse",
                        {
                          key: "gnb_footer_menu_" + menu.msgTitleId,
                          staticClass: "lst_sitemap_detail",
                          style: { display: _vm.isMobile ? "none" : "" },
                          attrs: {
                            tag: "ul",
                            id: "gnb_footer_menu_" + menu.msgTitleId
                          },
                          model: {
                            value: _vm.showCollapse[mapIdx][menuIdx],
                            callback: function($$v) {
                              _vm.$set(_vm.showCollapse[mapIdx], menuIdx, $$v)
                            },
                            expression: "showCollapse[mapIdx][menuIdx]"
                          }
                        },
                        _vm._l(menu.links, function(link, linkIdx) {
                          return _vm.isShow(link)
                            ? _c(
                                "li",
                                { key: linkIdx, staticClass: "link_item" },
                                [
                                  !!link.externalUrl
                                    ? _c(
                                        "a",
                                        {
                                          staticClass: "link_txt",
                                          attrs: {
                                            href: "" + link.externalUrl,
                                            target: "" + link.target
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n            " +
                                              _vm._s(
                                                link.useMsgId
                                                  ? _vm.$t(link.msgNameId)
                                                  : link.name
                                              ) +
                                              "\n          "
                                          )
                                        ]
                                      )
                                    : _vm.canUseRoute
                                      ? _c(
                                          "a",
                                          {
                                            staticClass: "link_txt",
                                            attrs: { href: link.url },
                                            on: {
                                              click: function($event) {
                                                !!link.externalUrl
                                                  ? _vm.routerProxy(
                                                      link.externalUrl,
                                                      $event
                                                    )
                                                  : _vm.routerProxy(
                                                      link.url,
                                                      $event
                                                    )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n            " +
                                                _vm._s(
                                                  link.useMsgId
                                                    ? _vm.$t(link.msgNameId)
                                                    : link.name
                                                ) +
                                                "\n          "
                                            )
                                          ]
                                        )
                                      : _c(
                                          "a",
                                          {
                                            staticClass: "link_txt",
                                            attrs: {
                                              href:
                                                "" +
                                                _vm.getDomain("homepage") +
                                                link.url
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n            " +
                                                _vm._s(
                                                  link.useMsgId
                                                    ? _vm.$t(link.msgNameId)
                                                    : link.name
                                                ) +
                                                "\n          "
                                            )
                                          ]
                                        )
                                ]
                              )
                            : _vm._e()
                        })
                      )
                    : _c(
                        "b-collapse",
                        {
                          key: "gnb_footer_menu_" + menu.msgTitleId,
                          staticClass: "lst_sitemap_detail",
                          style: { display: _vm.isMobile ? "none" : "" },
                          attrs: {
                            tag: "ul",
                            id: "gnb_footer_menu_" + menu.msgTitleId
                          },
                          model: {
                            value: _vm.showCollapse[mapIdx][menuIdx],
                            callback: function($$v) {
                              _vm.$set(_vm.showCollapse[mapIdx], menuIdx, $$v)
                            },
                            expression: "showCollapse[mapIdx][menuIdx]"
                          }
                        },
                        _vm._l(menu.links, function(links, linksIdx) {
                          return _c(
                            "ul",
                            { key: linksIdx, staticClass: "col_group" },
                            _vm._l(links, function(link, linkIdx) {
                              return !link.showOnlyMobile ||
                                (link.showOnlyMobile && _vm.isMobile)
                                ? _c(
                                    "li",
                                    { key: linkIdx, staticClass: "link_item" },
                                    [
                                      _vm.canUseRoute
                                        ? _c(
                                            "router-link-ex",
                                            {
                                              staticClass: "link_txt",
                                              attrs: { to: link.url }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  link.useMsgId
                                                    ? _vm.$t(link.msgNameId)
                                                    : link.name
                                                ) + "\n            "
                                              )
                                            ]
                                          )
                                        : _c(
                                            "a",
                                            {
                                              staticClass: "link_txt",
                                              attrs: {
                                                href:
                                                  "" +
                                                  _vm.getDomain("homepage") +
                                                  link.url
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  link.useMsgId
                                                    ? _vm.$t(link.msgNameId)
                                                    : link.name
                                                )
                                              )
                                            ]
                                          )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            })
                          )
                        })
                      )
                ]
              : _vm._e()
          })
        ],
        2
      )
    })
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }